<div class="card">
    <div class="card-body">
        <form #createForm="ngForm" class="needs-validation" novalidate *ngIf="!showAction.edit"
            (ngSubmit)="createForm.form.valid && submit(createForm)">
            <div class="row">
                <div class="col-12 col-md-6 mb-3" *ngFor="let column of formData; let i = index">
                    <div *ngIf="column.type == 'text' || column.type == 'number' || column.type == 'date' || column.type == 'email' || column.type == 'password'"
                        class="form-group has-validation">
                        <label [for]="column.name">{{ column.label }} <small
                                class="text-{{column.required === true ? 'danger': 'muted'}}">{{ column.required ===
                                true ? '*':
                                ''}}</small></label>
                        <input [type]="column.type" ngModel #i="ngModel" class="form-control" [name]="column.name"
                            [id]="column.name" [placeholder]="column.label" [required]="column?.required === true"
                            [pattern]="column?.regEx" [minlength]="column?.minLength" [maxlength]="column?.maxLength"
                            [ngClass]="{
                        'is-invalid': i.invalid && (i.dirty || i.touched || createForm.submitted),
                        'is-valid': i.valid && (i.dirty || i.touched)
                  }">
                        <div *ngIf="i.invalid && (i.dirty || i.touched || createForm.submitted)"
                            class="form-control-feedback">
                            <div *ngIf="i.errors?.['required']">
                                <small class="text-danger">{{column.label}} is required.</small>
                            </div>
                            <div *ngIf="i.errors?.['minlength']">
                                <small class="text-danger">{{column.label}} must be at least {{column.minLength}}
                                    characters
                                    long.</small>
                            </div>
                            <div *ngIf="i.errors?.['pattern']">
                                <small class="text-danger">
                                    Provide valid {{column.label}}
                                </small>
                            </div>
                        </div>

                    </div>
                    <div *ngIf="column.type == 'select' && column.name !== 'serviceType' && !column.dynamic"
                        class="form-group has-validation">
                        <label [for]="column.name">{{ column.label }} <small
                                class="text-{{column.required === true ? 'danger': 'muted'}}">{{ column.required ===
                                true ? '*':
                                ''}}</small></label>
                        <select class="form-control" (change)="getValue($event,column.name)" ngModel
                            [name]="column.name" [id]="column.name" [required]="column?.required === true"
                            autocomplete="test_{{column.name}}" #i="ngModel" [ngClass]="{
                        'is-invalid': i.invalid && (i.dirty || i.touched || createForm.submitted),
                        'is-valid': i.valid && (i.dirty || i.touched)
                  }">
                            <option selected disabled [ngValue]="">-- Select --</option>
                            <option *ngFor="let item of column.options" [ngValue]="item.value">{{item.name}}</option>
                        </select>
                        <div *ngIf="i.invalid && (i.dirty || i.touched || createForm.submitted)"
                            class="form-control-feedback">
                            <div *ngIf="i.errors?.['required']">
                                <small class="text-danger">{{column.label}} is required.</small>
                            </div>
                            <div *ngIf="i.errors?.['minlength']">
                                <small class="text-danger">{{column.label}} must be at least {{column.minLength}}
                                    characters
                                    long.</small>
                            </div>
                            <div *ngIf="i.errors?.['pattern']">
                                <small class="text-danger">
                                    <ol class="mb-0">
                                        <li> Number(0-9) & Special Character like @#$%^&)(*) Not Allowed</li>
                                    </ol>
                                </small>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="column.name === 'serviceType' && column.type === 'select' && !column.dynamic"
                        class="form-group mb-0">

                        <label class="form-label">Service Type</label>

                        <select ngModel name="serviceId" id="serviceId" class="form-control" #serviceIdCtrl="ngModel"
                            required [ngClass]="{
                'is-invalid': serviceIdCtrl.invalid && serviceIdCtrl.touched,
                'is-valid': serviceIdCtrl.valid && serviceIdCtrl.touched
            }">

                            <option selected disabled [ngValue]="">-- Select --</option>
                            <option *ngFor="let item of column.options" [value]="item.value">
                                {{ item.name }}
                            </option>
                        </select>

                        <div class="invalid-feedback">
                            Please enter Service Type
                        </div>
                    </div>
                    <div *ngIf="column.type == 'select' && column.dynamic === true" class="form-group has-validation">
                        <label [for]="column.name">{{ column.label }} <small
                                class="text-{{column.required === true ? 'danger': 'muted'}}">{{ column.required ===
                                true ? '*':
                                ''}}</small></label>
                        <select class="form-control" ngModel [name]="column.name" [id]="column.name"
                            [required]="column?.required === true" autocomplete="test_{{column.name}}" #i="ngModel"
                            [ngClass]="{
                            'is-invalid': i.invalid && (i.dirty || i.touched || createForm.submitted),
                            'is-valid': i.valid && (i.dirty || i.touched)
                      }">
                            <option selected disabled [ngValue]="">-- Select --</option>
                            <option *ngFor="let item of api.mappedList" [ngValue]="item.value">{{item.name}}</option>
                        </select>
                        <div *ngIf="i.invalid && (i.dirty || i.touched || createForm.submitted)"
                            class="form-control-feedback">
                            <div *ngIf="i.errors?.['required']">
                                <small class="text-danger">{{column.name}} is required.</small>
                            </div>
                            <div *ngIf="i.errors?.['minlength']">
                                <small class="text-danger">{{column.name}} must be at least {{column.minLength}}
                                    characters
                                    long.</small>
                            </div>
                            <div *ngIf="i.errors?.['pattern']">
                                <small class="text-danger">
                                    <ol class="mb-0">
                                        <li> Number(0-9) & Special Character like @#$%^&)(*) Not Allowed</li>
                                    </ol>
                                </small>
                            </div>
                        </div>
                    </div>
                    <div class="form-group has-validation" *ngIf="column.type == 'file'">
                        <label [for]="column.name">{{ column.label }} <small
                                class="text-{{column.required === true ? 'danger': 'muted'}}">{{ column.required ===
                                true ? '*':
                                ''}}</small></label>
                        <input [type]="column.type" ngModel class="form-control" [name]="column.name" [id]="column.name"
                            [placeholder]="column.label" (change)="selectFile($event)"
                            [required]="column?.required === true" #i="ngModel" [ngClass]="{
                            'is-invalid': i.invalid && (i.dirty || i.touched || createForm.submitted),
                            'is-valid': i.valid && (i.dirty || i.touched)
                      }">
                        <div *ngIf="i.invalid && (i.dirty || i.touched || createForm.submitted)"
                            class="form-control-feedback">
                            <div *ngIf="i.errors?.['required']">
                                <small class="text-danger">{{column.name}} is required.</small>
                            </div>

                        </div>
                    </div>

                    <div *ngIf="column.name === 'collectedId' && currentValue == 'collect'"
                        class="form-group has-validation">
                        <label [for]="column.name">{{ column.label }} <small
                                class="text-{{column.required === true ? 'danger': 'muted'}}">{{ column.required ===
                                true ? '*':
                                ''}}</small></label>
                        <input [type]="column.type" ngModel #i="ngModel" class="form-control" [name]="column.name"
                            [id]="column.name" [placeholder]="column.label" [required]="column?.required === true"
                            [pattern]="column?.regEx" [minlength]="column?.minLength" [maxlength]="column?.maxLength"
                            [ngClass]="{
                    'is-invalid': i.invalid && (i.dirty || i.touched || createForm.submitted),
                    'is-valid': i.valid && (i.dirty || i.touched)
              }">
                        <div *ngIf="i.invalid && (i.dirty || i.touched || createForm.submitted)"
                            class="form-control-feedback">
                            <div *ngIf="i.errors?.['required']">
                                <small class="text-danger">{{column.label}} is required.</small>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="col-md-12 mb-4" *ngIf="editRoutePath === 'user/getDataById'">
                    <label for="assignedServices" class="col-form-label "> Select Services</label>
                    <ng-select [items]="mappedList" bindLabel="text" [(ngModel)]="assignedServices"
                        name="assignedServices" bindValue="id" [multiple]="true">
                        <ng-template ng-header-tmp>

                            <div>
                                <button class="btn btn-link" type="button" (click)="onSelectAll()">Select All</button>
                                <button class="btn btn-link" type="button" (click)="onClearAll()">Clear All</button>
                            </div>

                        </ng-template>
                    </ng-select>
                </div>
                <div class="col-12 text-center mt-3">
                    <button class="btn btn-success" type="submit" [disabled]="createForm.invalid">
                        <i class="fa fa-check-circle" aria-hidden="true"></i>
                        Submit
                    </button> &nbsp;&nbsp;&nbsp;
                    <button class="btn btn-danger" type="reset" [disabled]="!createForm.dirty">
                        <i class="fa fa-stop-circle" aria-hidden="true"></i>
                        Reset
                    </button>
                </div>
            </div>

        </form>

        <form #updateForm="ngForm" (submit)="updatedata(updateForm)" *ngIf="showAction.edit && api.editableData">

            <div class="row">
                <div class="col-12 col-md-6 mb-3" *ngFor="let column of formData; let i = index">
                    <div *ngIf="column.type == 'text' || column.type == 'number' || column.type == 'date' || column.type == 'email' || column.type == 'password'"
                        class="form-group has-validation">
                        <label [for]="column.name">{{ column.label }} <small
                                class="text-{{column.required === true ? 'danger': 'muted'}}">{{ column.required ===
                                true ? '*':
                                ''}}</small></label>
                        <input [type]="column.type" [(ngModel)]="api.editableData[column.name]" #i="ngModel"
                            class="form-control" [name]="column.name" [id]="column.name" [placeholder]="column.label"
                            [required]="column?.required === true" [pattern]="column?.regEx"
                            [minlength]="column?.minLength" [maxlength]="column?.maxLength" [ngClass]="{
                      'is-invalid': i.invalid && (i.dirty || i.touched || updateForm.submitted),
                      'is-valid': i.valid && (i.dirty || i.touched)
                }">
                        <div *ngIf="i.invalid && (i.dirty || i.touched || updateForm.submitted)"
                            class="form-control-feedback">
                            <div *ngIf="i.errors?.['required']">
                                <small class="text-danger">{{column.name}} is required.</small>
                            </div>
                            <div *ngIf="i.errors?.['minlength']">
                                <small class="text-danger">{{column.name}} must be at least {{column.minLength}}
                                    characters
                                    long.</small>
                            </div>
                            <div *ngIf="i.errors?.['pattern']">
                                <small class="text-danger">
                                    Provide valid {{column.name}}
                                </small>
                            </div>
                        </div>

                    </div>
                    <div *ngIf="column.type == 'select' && !column.dynamic" class="form-group has-validation">
                        <label [for]="column.name">{{ column.label }} <small
                                class="text-{{column.required === true ? 'danger': 'muted'}}">{{ column.required ===
                                true ? '*':
                                ''}}</small></label>
                        <select class="form-control" (change)="getValue($event,column.name)"
                            [(ngModel)]="api.editableData[column.name]" [name]="column.name" [id]="column.name"
                            [required]="column?.required === true" autocomplete="test_{{column.name}}" #i="ngModel"
                            [ngClass]="{
                      'is-invalid': i.invalid && (i.dirty || i.touched || updateForm.submitted),
                      'is-valid': i.valid && (i.dirty || i.touched)
                }">
                            <option selected disabled [ngValue]="">-- Select --</option>
                            <option *ngFor="let item of column.options" [ngValue]="item.value">{{item.name}}</option>
                        </select>
                        <div *ngIf="i.invalid && (i.dirty || i.touched || updateForm.submitted)"
                            class="form-control-feedback">
                            <div *ngIf="i.errors?.['required']">
                                <small class="text-danger">{{column.name}} is required.</small>
                            </div>
                            <div *ngIf="i.errors?.['minlength']">
                                <small class="text-danger">{{column.name}} must be at least {{column.minLength}}
                                    characters
                                    long.</small>
                            </div>
                            <div *ngIf="i.errors?.['pattern']">
                                <small class="text-danger">
                                    <ol class="mb-0">
                                        <li> Number(0-9) & Special Character like @#$%^&)(*) Not Allowed</li>
                                    </ol>
                                </small>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="column.type == 'select' && column.dynamic === true" class="form-group has-validation">
                        <label [for]="column.name">{{ column.label }} <small
                                class="text-{{column.required === true ? 'danger': 'muted'}}">{{ column.required ===
                                true ? '*':
                                ''}}</small></label>
                        <select class="form-control" [(ngModel)]="api.editableData[column.name]" [name]="column.name"
                            [id]="column.name" [required]="column?.required === true"
                            autocomplete="test_{{column.name}}" #i="ngModel" [ngClass]="{
                      'is-invalid': i.invalid && (i.dirty || i.touched || updateForm.submitted),
                      'is-valid': i.valid && (i.dirty || i.touched)
                }">
                            <option selected disabled [ngValue]="">-- Select --</option>
                            <option *ngFor="let item of api.mappedList" [ngValue]="item.value">{{item.name}}</option>
                        </select>
                        <div *ngIf="i.invalid && (i.dirty || i.touched || updateForm.submitted)"
                            class="form-control-feedback">
                            <div *ngIf="i.errors?.['required']">
                                <small class="text-danger">{{column.name}} is required.</small>
                            </div>
                            <div *ngIf="i.errors?.['minlength']">
                                <small class="text-danger">{{column.name}} must be at least {{column.minLength}}
                                    characters
                                    long.</small>
                            </div>
                            <div *ngIf="i.errors?.['pattern']">
                                <small class="text-danger">
                                    <ol class="mb-0">
                                        <li> Number(0-9) & Special Character like @#$%^&)(*) Not Allowed</li>
                                    </ol>
                                </small>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="column.type == 'textarea'" class="form-group has-validation">
                        <label [for]="column.name">{{ column.label }} <small
                                class="text-{{column.required === true ? 'danger': 'muted'}}">{{ column.required ===
                                true ? '*':
                                ''}}</small></label>
                        <textarea class="form-control" [(ngModel)]="api.editableData[column.name]" [name]="column.name"
                            [id]="column.name" rows="3" [required]="column?.required === true" #i="ngModel" [ngClass]="{
                      'is-invalid': i.invalid && (i.dirty || i.touched || updateForm.submitted),
                      'is-valid': i.valid && (i.dirty || i.touched)
                }"></textarea>
                        <div *ngIf="i.invalid && (i.dirty || i.touched || updateForm.submitted)"
                            class="form-control-feedback">
                            <div *ngIf="i.errors?.['required']">
                                <small class="text-danger">{{column.name}} is required.</small>
                            </div>


                        </div>
                    </div>
                    <div *ngIf="column.name === 'collectedId'  && currentValue === 'collect'"
                        class="form-group has-validation">
                        <label [for]="column.name">{{ column.label }} <small
                                class="text-{{column.required === true ? 'danger': 'muted'}}">{{ column.required ===
                                true ? '*':
                                ''}}</small></label>
                        <input [type]="column.type" ngModel #i="ngModel" [(ngModel)]="api.editableData[column.name]"
                            class="form-control" [name]="column.name" [id]="column.name" [placeholder]="column.label"
                            [required]="column?.required === true" [pattern]="column?.regEx"
                            [minlength]="column?.minLength" [maxlength]="column?.maxLength" [ngClass]="{
                    'is-invalid': i.invalid && (i.dirty || i.touched || updateForm.submitted),
                    'is-valid': i.valid && (i.dirty || i.touched)
              }">
                        <div *ngIf="i.invalid && (i.dirty || i.touched || updateForm.submitted)"
                            class="form-control-feedback">
                            <div *ngIf="i.errors?.['required']">
                                <small class="text-danger">{{column.label}} is required.</small>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="col-md-12 mb-4" *ngIf="editRoutePath === 'user/getDataById'">
                    <label for="assignedServices" class="col-form-label "> Select Services</label>
                    <ng-select [items]="mappedList" bindLabel="text" [(ngModel)]="api.editableData.assignedServices"
                        name="assignedServices" bindValue="id" [multiple]="true">
                        <ng-template ng-header-tmp>

                            <div>
                                <button class="btn btn-link" type="button" (click)="onSelectAll()">Select All</button>
                                <button class="btn btn-link" type="button" (click)="onClearAll()">Clear All</button>
                            </div>

                        </ng-template>
                    </ng-select>
                </div>
                <div class="col-12 text-center mt-3">
                    <button class="btn btn-success" type="submit">
                        <i class="fa fa-check-circle" aria-hidden="true"></i>
                        Submit
                    </button> &nbsp;&nbsp;&nbsp;
                    <button class="btn btn-danger" type="button" (click)="getOne()">
                        <i class="fa fa-stop-circle" aria-hidden="true"></i>
                        Reset
                    </button>
                </div>
            </div>
        </form>
    </div>
</div>